// import PropTypes from 'prop-types';
// import { forwardRef } from 'react';
// import { Link as RouterLink } from 'react-router-dom';
// @mui
// import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';

import { logoTypes } from '../../../../configs/logoConfigs'

// ----------------------------------------------------------------------

const SystemLogo = ({ routeType, logoType }) => {
  // const theme = useTheme();

  // const PRIMARY_LIGHT = theme.palette.primary.light;

  // const PRIMARY_MAIN = theme.palette.primary.main;

  // const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );


  let imgSrc = '';

  if (logoType === logoTypes.login) {
    imgSrc = '/assets/images/customization/sdgrouphub/logoLogin.png';
  }

  if (logoType === logoTypes.sidebar) {
    imgSrc = '/assets/images/customization/sdgrouphub/logoSidebar.png';
  }

  const logo = (
    <Box
      // ref={ref}
      component="div"
      sx={{
        width: 150,
        // height: 40,
        display: 'inline-flex',
        // ...sx,
      }}
    // {...other}
    >
      <img
        src={imgSrc}
        alt="System Logo"
      />
    </Box>
  );

  // if (disabledLink) {
  //   return <>{logo}</>;
  // }

  return (
    <>
      {logo}
    </>
    // <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
    // {logo}
    // </Link>
  );
};

// SystemLogo.propTypes = {
//   sx: PropTypes.object,
//   disabledLink: PropTypes.bool,
// };

export default SystemLogo;
